export default __webpack_public_path__ + "static/media/ev-car-hire.36049527.svg";